import gql from 'graphql-tag';

const CREATE_CHART = gql`
  mutation($input: ChartInput!) {
    createChart(input: $input) {
      chartId
      name
      description
      groupBy #GroupBy
      metrics {
        metricId
        name
        attribute
        metricFunction # MetricFunction
        filterCondition
        metricUnit
        metricOrder
        denominator
      }
      entity
      createdBy {
        userId
        name
        email
      }
      createdTime
      defaultChartType # when the user request to view the chart, it will be rendered in this type first time then the user can switch chart types. It will be available in single GET only.
      # possibleChartTypes
    }
  }
`;

const UPDATE_CHART = gql`
  mutation($chartId: ID!, $input: ChartInput!) {
    updateChart(chartId: $chartId, input: $input) {
      chartId
      name
      description
      groupBy #GroupBy
      metrics {
        metricId
        name
        attribute
        metricFunction # MetricFunction
        filterCondition
        metricUnit
        metricOrder
        denominator
      }
      entity
      createdBy {
        userId
        name
        email
      }
      createdTime
      defaultChartType # when the user request to view the chart, it will be rendered in this type first time then the user can switch chart types. It will be available in single GET only.
      # possibleChartTypes
    }
  }
`;

const DELETE_CHART = gql`
  mutation($chartId: ID!) {
    deleteChart(chartId: $chartId)
  }
`;

const DELETE_CHARTS = gql`
  mutation($chartIds: [ID]!) {
    deleteCharts(chartIds: $chartIds)
  }
`;

export { CREATE_CHART, UPDATE_CHART, DELETE_CHART, DELETE_CHARTS };
